import host from './host';

export const msalConfig = {
    auth: {
        clientId: host.azureClientId,
        authority: `https://login.microsoftonline.com/${host.azureTenantId}`,
        redirectUri: host.azureRedirectUri,
        response_type: 'id_token'
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
          loggerCallback: (level, message, containsPII) => {
          },
          logLevel: 'Verbose' // Set the log level to 'Verbose' (providing detailed logs including debug information).
        }
      }
  };
  

export const loginRequest = {
    scopes: ["User.Read"]
  };
  
